module.exports = fox._r("images/favorite.gif", __webpack_public_path__ + "images/favorite.gif");


//////////////////
// WEBPACK FOOTER
// ./images/favorite.gif
// module id = 1042
// module chunks = 4